<template>
  <div class="opc-partner-warning">
    <div class="opc-partner-warning__inner">
      <img :src="zmLogo" alt="" class="opc-partner-warning__zm-logo" />
      <img :src="warningUrl" alt="" class="opc-partner-warning__bg" />
      <p class="opc-partner-warning__desc">{{$t('billing.partner.unsupport_device_tips')}}</p>
    </div>
  </div>
</template>

<script>
import zmLogo from '@/assets/partner/zm-logo.svg';
import warningUrl from '@/assets/partner/warning.svg';

export default {
  name: 'UnSupportDeviceForPartner',
  data() {
    return {
      zmLogo,
      warningUrl,
    };
  },
  methods: {
    hiddenSomeElement() {
      const header = document.getElementById('new_buyflow_header_container');
      header && (header.style.display = 'none');
    },
  },
  mounted() {
    this.hiddenSomeElement();
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.opc-partner-warning {
  margin: auto;
  background: #F7F7F8;
  height: 100vh;
  position: fixed;
  top: 0px;
  overflow-y: auto;

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 53px 45px 55px;
  }

  &__zm-logo {
    margin-bottom: 145px;
    width: 113px;
    height: 26px;
  }

  &__bg {
    margin-bottom: 40px;
    width: 134px;
    height: 152px;
  }

  &__desc {
    font-family: $happy-display;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    text-align: center;
    color: #00031F;
    padding-bottom: 200px;
  }
}
</style>
